function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

module.exports = _interopRequireDefault;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@babel/runtime/helpers/interopRequireDefault.js
// module id = ../node_modules/@babel/runtime/helpers/interopRequireDefault.js
// module chunks = 0